/// <amd-module name="Artifacts/FeedPicker/helpers/SelectionHelper" />

import { IFeedIdentity } from "Artifacts/Root/types";
import { IListBoxItem } from "VSSUI/ListBox";
import { ISelectionRange } from "VSSUI/Utilities/Selection";

const addHeadersDividersToUnselectableRanges = (
  ranges: ISelectionRange[],
  index: number,
  feeds: IListBoxItem<IFeedIdentity>[],
) => {
  for (let i = 1; i < feeds.length; i++) {
    const item1 = feeds[i];
    const item2 = feeds[i - 1];
    if (item1.groupId !== item2.groupId) {
      ranges.push({ beginIndex: index, endIndex: index + 1 });
      index += 2;
    }
    index++;
  }
  return index;
};

const getAllUnselectablesForFeedTab = (
  ranges: ISelectionRange[],
  index: number,
  feedList: IListBoxItem<IFeedIdentity>[],
) => {
  feedList.sort((a: IListBoxItem, b: IListBoxItem) => {
    if (a.groupId && b.groupId && a.groupId > b.groupId) {
      return -1;
    } else if (a.groupId && b.groupId && a.groupId < b.groupId) {
      return 1;
    }
    return 0;
  });
  ranges.push({ beginIndex: index, endIndex: index });
  index += 2;
  if (feedList.length < 1) {
    ranges.pop();
    index -= 2;
  }
  index = addHeadersDividersToUnselectableRanges(ranges, index, feedList);
  return index;
};

export function getFeedPickerUnselectableRanges(
  feeds: Array<IListBoxItem<IFeedIdentity>[]>,
): ISelectionRange[] {
  const ranges: ISelectionRange[] = [];
  let currentIndex = 0;
  feeds.forEach((feedIdentityList) => {
    currentIndex = getAllUnselectablesForFeedTab(ranges, currentIndex, feedIdentityList);
  });
  return ranges;
}
